module.exports = __webpack_public_path__ + "svg/vue.58aa49.svg";